module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"list_lead":"Leads List","LeadCloseModalTitle":"Close Lead","QuotationCreateModalTitle":"Select Quotation Type"},"si":{"list_lead":"කැඳවුම් ලැයිස්තුව","LeadCloseModalTitle":"Close Lead","QuotationCreateModalTitle":"Select Quotation Type"},"ta":{"list_lead":"Leads List","LeadCloseModalTitle":"Close Lead","QuotationCreateModalTitle":"Select Quotation Type"}}')
  delete Component.options._Ctor
}
